module.exports = __webpack_public_path__ + "static/media/lumen-search.445df24e.jpg";